export enum enumBatchImportItemType {
  ISF,
  ENTRY_SUMMARY,
}
